import { useQuery } from '@tanstack/react-query'
import { Space } from 'antd'
import invoiceApi from 'api/invoiceApi'
import ticketApi from 'api/ticketApi'
import dayjs from 'dayjs'
import { listTaxMessageInvoiceFromPosQueries } from 'features/TaxMessage/screens/ListTaxMessageInvoiceFromPos/queries'
import CustomAntSelect from 'general/components/CustomAntSelect'
import CustomDataTable from 'general/components/CustomDataTable'
import CustomLabel from 'general/components/CustomLabel'
import CustomTag from 'general/components/CustomTag'
import { IconAction } from 'general/components/GroupButton/styles'
import TableAction from 'general/components/GroupButton/TableAction'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import SelectOptions from 'general/constants/SelectOptions'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import useExportById from 'hooks/Mutations/useExportById'
import { useMemo, useRef, useState } from 'react'

export default function InvoiceFromPosList({
  open,
  onOpenChange,
  invoiceIds,
  ticketIds,
  invoiceType,
}) {
  const modalRef = useRef(null)
  const [filter, setFilter] = useState()

  const { data, isFetching } = useQuery(
    listTaxMessageInvoiceFromPosQueries.detailInvoice({
      invoiceIdsArray: invoiceIds || [],
      ticketIds: ticketIds || [],
      invoiceType,
      classify: 'MTT',
      ...filter,
    }),
  )

  const { exportFunc } = useExportById(
    (ticketId) => ticketApi.exportById(ticketId),
    'Vé đã xuất.pdf',
    'application/pdf',
  )
  const { exportFunc: exportInvoiceFunc } = useExportById(
    (invoiceId) => invoiceApi.exportInvoiceById(invoiceId),
    'Hóa đơn đã xuất.pdf',
    'application/pdf',
  )

  const defaultColumns = useMemo(() => {
    /** @type {import('react-data-table-component').TableColumn<TaxMessageInvoiceFromPos['summaryDetail'][0]>[]} */
    const arr = [
      {
        id: 'serial',
        name: 'Ký hiệu',
        center: true,
        selector: (row) => row.serial,
      },
      {
        id: 'dateInvoice',
        name: 'Ngày hóa đơn',
        center: true,
        selector: (row) => row.date,
        format: (row) =>
          dayjs(row.date).isValid() ? dayjs(row.date).format('L') : null,
      },
      {
        id: 'invoiceNo',
        name: 'Số hóa đơn',
        center: true,
        selector: (row) => row.no,
      },
      {
        id: 'taxAuthorityCode',
        name: 'Mã của CQT',
        center: true,
        minWidth: '200px',
        selector: (row) => row.taxAuthorityCode,
      },
      {
        id: 'sendTaxStatus',
        name: 'Trạng thái',
        center: true,
        selector: (row) => row.sendTaxStatus,
        format: (row) => {
          const { color, text } = InvoiceHelper.renderSendTaxStatus(
            row.sendTaxStatus,
          )
          return (
            <CustomTag
              text={text}
              tagProps={{
                className: 'badge badge-light-' + color,
              }}
            />
          )
        },
      },
      {
        name: 'Hành động',
        center: true,
        compact: true,
        cell: (row) => (
          <Space onClick={() => {}}>
            <TableAction
              titleActionText="Xem chi tiết"
              icon={<IconAction className="fa-light fa-eye" />}
              onClick={() => {
                if (invoiceType === 'INVOICE') {
                  exportInvoiceFunc(row.invoiceId)
                } else if (invoiceType === 'TICKET') {
                  exportFunc(row.ticketId)
                }
              }}
            />
          </Space>
        ),
      },
    ]
    return arr
  }, [])

  return (
    <DraggableModal
      ref={modalRef}
      title="Danh sách hóa đơn"
      isOpen={open}
      onOpenChange={(value) => {
        setFilter({})
        onOpenChange(value)
      }}
      cancelText="Đóng"
      hasApplyButton={false}
      width="80%"
      styles={{
        body: {
          padding: 0,
        },
      }}
    >
      <div className="bg-secondary">
        <div className="pl-5 my-5">
          <CustomLabel text="Trạng thái" width={'fit-content'} />
          <CustomAntSelect
            defaultValue={null}
            value={filter?.sendTaxStatus || null}
            options={SelectOptions.sendTaxStatus}
            onChange={(value) => {
              !value
                ? setFilter({ sendTaxStatus: undefined })
                : setFilter({ sendTaxStatus: value })
            }}
            className="ml-3 w-200px"
          />
        </div>
        <CustomDataTable
          isLoading={isFetching}
          persistTableHead
          columns={defaultColumns}
          dataSource={data?.rows}
          scrollY="70vh"
        />
      </div>
    </DraggableModal>
  )
}
